import { Resources } from 'constants/resources';

import { useEffect, useRef } from 'react';

import { RaRecord } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  AutocompleteInputSynced,
  DateTimeInput,
  EnumAutocompleteInput,
  TextInput,
} from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';

import { OrderManualCreateSection } from './OrderManualCreateSection';

export const OrderManualCreateGeneralFields = () => {
  const { setValue, getValues, trigger, formState } = useFormContext();
  const createdAt = useWatch({ name: 'createdAt' });
  const lastAutoValue = useRef<number | null>(null);

  useEffect(() => {
    const updatedAt = getValues('updatedAt');

    if (updatedAt === null || updatedAt === lastAutoValue.current) {
      lastAutoValue.current = createdAt;
      setValue('updatedAt', createdAt, { shouldValidate: formState.isSubmitted });
    } else if (formState.isSubmitted) {
      trigger('updatedAt');
    }
  }, [createdAt]);

  return (
    <OrderManualCreateSection title="Общая информация">
      <EnumAutocompleteInput
        filterToQuery={(searchText: string) => ({ description: searchText })}
        helperText={false}
        isRequired
        label="Направление"
        optionText="description"
        optionValue="value"
        resource={Resources.Directions}
        source="direction"
        variant="outlined"
      />
      <EnumAutocompleteInput
        filterToQuery={(searchText: string) => ({ description: searchText })}
        helperText={false}
        isRequired
        label="Статус"
        optionText="description"
        optionValue="value"
        resource={Resources.NewOrderStatuses}
        source="status"
        variant="outlined"
      />
      <TextInput helperText={false} isRequired label="Сумма" source="amount" variant="outlined" />
      <ReferenceInput
        filter={{ active: true, groups: ['reference'] }}
        perPage={50}
        reference={Resources.Currencies}
        source="currencyId"
      >
        <AutocompleteInputSynced
          filterToQuery={(searchText: string) => ({ currency: searchText })}
          helperText={false}
          isRequired
          label="Валюта"
          optionText={(record: RaRecord) => `${record?.alphaCode}, ${record?.name}`}
          syncFields={{ currency: 'alphaCode' }}
          variant="outlined"
        />
      </ReferenceInput>
      <ReferenceInput
        disableReferenceFilter={true}
        perPage={300}
        reference={Resources.Countries}
        source="countryId"
      >
        <AutocompleteInputSynced
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          isRequired
          label="Страна"
          optionText="name"
          syncFields={{ country: 'alphaCode' }}
          variant="outlined"
        />
      </ReferenceInput>
      <DateTimeInput
        applyOnInput
        label="Время создания"
        maxDate={new Date()}
        required
        source="createdAt"
      />
      <DateTimeInput applyOnInput label="Время исполнения" required source="updatedAt" />
      <TextInput
        helperText={false}
        isRequired
        label="Мерчант ID"
        source="merchantReferenceId"
        variant="outlined"
      />
      <TextInput
        helperText={false}
        isRequired
        label="Провайдер ID"
        source="providerReferenceId"
        variant="outlined"
      />
    </OrderManualCreateSection>
  );
};
